import React from "react";
import { Link } from "react-router-dom";

import IntegrationCards from "../../Components/EmployersComponents/EMP_integration/IntegrationCards";
import FeaturedIntegrationPartners from "../../Components/EmployersComponents/EMP_integration/FeaturedIntegrationPartners";
import IntegrationContact from "../../Components/EmployersComponents/EMP_integration/IntegrationContact";
import SolutionSection from "../../Components/EmployersComponents/EMP_integration/SolutionSection";
import Footer from "../../Components/Footer";


import adp from "../../assets/EMP_integration/adp-platinum.webp";
import workday from "../../assets/EMP_integration/dp-workday-logo-2.webp";
import isolved from "../../assets/EMP_integration/Isolved-logo.webp";import alight from "../../assets/EMP_integration/market-place-alight.png.webp";
import hha from "../../assets/EMP_integration/market-place-hha-exchange.png.webp";
import oracle from "../../assets/EMP_integration/oracle-partner-logos.png.webp";
import par from "../../assets/EMP_integration/par-logo.webp";
import paychex from "../../assets/EMP_integration/paychex-logo.png.webp";
import payday from "../../assets/EMP_integration/payday-portal-logo.png.webp";
import paylocity from "../../assets/EMP_integration/paylocity-logo.svg";
import sap from "../../assets/EMP_integration/sap-partner-logo.png.webp";
import viventium from "../../assets/EMP_integration/Viventium-logo.png.webp";

const column1 = [adp, workday, isolved, alight];
const column2 = [hha, oracle, par, paychex];
const column3 = [payday, paylocity, sap, viventium];
const column4 = [workday, alight, oracle, paylocity];
const column5 = [sap, paychex, par, payday];

const LogoCard = ({ image }) => {
  return (
    <div className="w-full h-[95px] sm:h-[105px] lg:h-[110px] bg-white  rounded-sm flex items-center justify-center shadow-sm">
      <img
        src={image}
        alt="logo"
        className="max-w-[90px] sm:max-w-[105px] lg:max-w-[115px] object-contain opacity-90"
      />
    </div>
  );
};

const EMP_integration= () => {
  return (
    <>
      <style>
        {`
          .scroll-up {
            animation: scrollUp 50s linear infinite;
          }

          .scroll-down {
            animation: scrollDown 50s linear infinite;
          }

          @keyframes scrollUp {
            0% {
              transform: translateY(0%);
            }

            100% {
              transform: translateY(-50%);
            }
          }

          @keyframes scrollDown {
            0% {
              transform: translateY(-50%);
            }

            100% {
              transform: translateY(0%);
            }
          }
        `}
      </style>

      <section className="w-full bg-[white] py-16 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col lg:flex-row gap-14 items-center">
          
          {/* LEFT SIDE */}
          <div className="w-full lg:w-[42%] lg:-ml-[50px]">
            <p className="text-[#532002] uppercase tracking-[1.5px] text-sm  lg:-mt-[50px] font-bold lg:mb-5 ">
              Integrations Marketplace
            </p>

            <h1 className="text-[52px] sm:text-[64px] lg:text-[48px] leading-[1.05] lg:leading-[50px] text-[#2d0902] font-serif font-light">
  It’s never been easier
  <br />
  to launch DailyPay
</h1>

           <p className="text-[#222] text-[18px] lg:text-[16px] font-[600] leading-8 lg:leading-6 mb-10 max-w-[520px] lg:mt-[35px]">
  Seamless integration means your payroll runs exactly
  <br className="hidden lg:block" />
  as it does today, with the added benefit of the 
    <br className="hidden lg:block" />

  industry’s best On-Demand
  Pay.
</p>

            <div className="flex flex-wrap gap-4">
      <div className="flex flex-wrap gap-3">
  
  <button className="bg-[#2d0902] text-white px-4 py-2 sm:px-5 sm:py-2.5 lg:px-5 lg:py-2 text-sm sm:text-base font-semibold hover:opacity-90 transition">
    Book a Demo
  </button>


<button
  onClick={() => {
    const section = document.getElementById("featured-integrations");

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }}
  className="border-2 border-[#2d0902] text-[#2d0902] px-4 py-2 sm:px-5 sm:py-2.5 lg:px-5 lg:py-2 text-sm sm:text-base font-semibold hover:bg-[#2d0902] hover:text-white transition"
>
  View all integrations
</button>
  

</div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="w-full lg:w-[58%] h-[620px] relative overflow-hidden">
            
            <div className="grid grid-cols-5 gap-5 h-full">
              
              {/* COLUMN 1 */}
              <div className="overflow-hidden">
                <div className="flex flex-col gap-5 scroll-up">
                  {[...column1, ...column1].map((logo, index) => (
                    <LogoCard image={logo} key={index} />
                  ))}
                </div>
              </div>

              {/* COLUMN 2 */}
              <div className="overflow-hidden">
                <div className="flex flex-col gap-5 scroll-down">
                  {[...column2, ...column2].map((logo, index) => (
                    <LogoCard image={logo} key={index} />
                  ))}
                </div>
              </div>

              {/* COLUMN 3 */}
              <div className="overflow-hidden">
                <div className="flex flex-col gap-5 scroll-up">
                  {[...column3, ...column3].map((logo, index) => (
                    <LogoCard image={logo} key={index} />
                  ))}
                </div>
              </div>

              {/* COLUMN 4 */}
              <div className="overflow-hidden">
                <div className="flex flex-col gap-5 scroll-down">
                  {[...column4, ...column4].map((logo, index) => (
                    <LogoCard image={logo} key={index} />
                  ))}
                </div>
              </div>

              {/* COLUMN 5 */}
              <div className="overflow-hidden">
                <div className="flex flex-col gap-5 scroll-up">
                  {[...column5, ...column5].map((logo, index) => (
                    <LogoCard image={logo} key={index} />
                  ))}
                </div>
              </div>
            </div>

            {/* TOP FADE */}
            <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[white] to-transparent z-20"></div>

            {/* BOTTOM FADE */}
            <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[white] to-transparent z-20"></div>
          </div>
        </div>
      </section>
      <IntegrationCards />
      <FeaturedIntegrationPartners />
      <SolutionSection />
      <IntegrationContact />
      
      <Footer />
    </>
  );
};

export default EMP_integration;